import { SubscriptionData } from './subscription-data';
export interface AccountMagicLink {
    magicLinkId: string;
    subIds: string[];
    active: boolean;
    account?: {
        accountId: string;
        accountName: string;
    };
    subscriptions?: SubscriptionData[];
    regLink?: string;
}

export interface CreateMagicLinkResponse {
    accountId: string;
    magicLinkId: string
}
